

export const centermenusList = [
    {name:"基本信息",path:"/center/basicinformation"},
    {name:"我的预约",path:"/center/myappointment"},
    {name:"我的收藏",path:"/center/mymollection"},
    {name:"我发布的成果",path:"/center/myachievements"},
    {name:"我发布的需求",path:"/center/mydemands"},
    {name:"青年科学家招募",path:"/center/myscientist"},

]
export const headermenusList = [
    {name:"首页",path:"/"},
    {name:"设备共享",path:"/equipmentsharing"},
    {name:"供需对接",path:"/supplysndsemand"},
    {name:"微纳大赛",path:"/competition"},
    {name:"大赛反馈",path:"/competitionquestion"},
    {name:"沭聚物联",path:"/shujuwulian"},
    {name:"青年科学家招募",path:"/scientist"},
    {name:"专家库",path:"/thinktank"},
    {name:"资料下载",path:"/datadownload"},
    {name:"平台介绍",path:"/platformintroduction"},
    {name:"通知公告",path:"/noticeannouncement"},
]
export const competitionList = [
    {name:"大赛简介",path:"introduction"},
    {name:"大赛公告",path:"announcement"},
    {name:"往届大赛",path:"previous"},
    {name:"注册参赛",path:"register"}
]
export const supplyAndDemmandList = [
    {name:"成果展示",path:"supply"},
    {name:"需求大厅",path:"demmand"},
]
